import React from 'react'
import style from './style.module.css'

interface HeaderProps {
  imgSrc?: string
  imgStyle?: React.CSSProperties
}

export const Header = ({
  imgSrc = 'assets/courier-logo@2x.png',
  imgStyle,
}: HeaderProps) => {
  return (
    <div className={style.header}>
      <img
        src={imgSrc}
        alt="courierappLogo"
        className={style.logo}
        style={imgStyle}
      />
    </div>
  )
}

export default Header
